import { OnInit } from '@angular/core';
import { Globals } from '../objects/Globals';
import { JobService } from '../services/job.service';
import { MainLoadingService } from '../services/main-loading.service';
import { Router } from '@angular/router';
var QuickLinksPanelComponent = /** @class */ (function () {
    function QuickLinksPanelComponent(globals, jobService, mainLoadingService, router) {
        this.globals = globals;
        this.jobService = jobService;
        this.mainLoadingService = mainLoadingService;
        this.router = router;
        this.isEpic = false;
        this.hidePanel = false;
        this.selectedValue = 'Quick Links';
        this.availableImages = ['VIEWPR', 'CREATEPR', 'VIEWPO', 'CREATEPO', 'VIEWRFQ', 'CREATERFQ', 'VIEWSN', 'CREATESN', 'VIEWIV', 'CREATEIV', 'VIEWEBID', 'CREATEEBID', 'VIEWSUPPLIER', 'MANAGESUPPLIER', 'Template'];
    }
    QuickLinksPanelComponent.prototype.ngOnInit = function () {
        this.getJobList();
        this.valueSelection = [];
        this.valueSelection.push({ ItemValue: "quick", ItemDisplay: "Quick Links" });
    };
    QuickLinksPanelComponent.prototype.getJobList = function () {
        var _this = this;
        if (this.globals.Session) {
            this.jobService.createJobList('dashboard').subscribe(function (result) {
                _this.componentId = result;
                _this.refreshJobListCard();
            });
        }
    };
    QuickLinksPanelComponent.prototype.refreshJobListCard = function () {
        var _this = this;
        if (this.componentId) {
            this.jobService.getJobList(this.componentId).subscribe(function (result) {
                _this.jobList = JSON.parse(result);
            });
        }
    };
    QuickLinksPanelComponent.prototype.triggerJob = function (jobId) {
        var _this = this;
        if (jobId) {
            this.mainLoadingService.setLoading(true);
            this.jobService.triggerJob(this.componentId, jobId).subscribe(function (result) {
                var resultObject = JSON.parse(result);
                if (resultObject.ReturnType == "0") {
                    if (resultObject.Arguments) {
                        var path = [];
                        resultObject.Arguments.forEach(function (element) {
                            path.push(element);
                        });
                        ;
                        _this.router.navigate(path);
                    }
                }
                _this.mainLoadingService.setLoading(false);
            }, function (error) {
                _this.mainLoadingService.setLoading(false);
            });
        }
    };
    return QuickLinksPanelComponent;
}());
export { QuickLinksPanelComponent };
